import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getProvidersUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/providers_clients`;

const toggleProviderUrl = (pId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/providers_clients/${pId}/toggle`;

const getProviderByIdUrl = (pId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/providers_clients/${pId}`;

const updateProviderUrl = (pId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/providers_clients/${pId}`;

const addProviderUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/providers_clients`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });
    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getProvidersUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(providerId, companyId, subcompanyId) {
    const url = toggleProviderUrl(providerId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(providerId, companyId, subcompanyId) {
    const url = getProviderByIdUrl(providerId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(providerId, companyId, subcompanyId, provider) {
    const url = updateProviderUrl(providerId, companyId, subcompanyId);
    return this.axios
      .put(url, provider, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, provider) {
    const url = addProviderUrl(companyId, subcompanyId);
    return this.axios
      .post(url, provider, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/providers.api.js